<template>

  <polygon
      :data-id="pointer.id"
      :points="pointer.coordinates"
      :class="[status, {blink: !$store.state.apiData.highlight}, {available: objectCount }, {active:selectedPol == index || active}, ]"
      @click="polygonSelect(); selected = index"
  ></polygon>

</template>


<script>


  export default {
    props: ['pointer', 'index', 'selectedPol', 'map', 'active'],
      data() {
          return {
              status: 'normal',
              selected: this.selectedPol,
              parent: this.$parent,

          }
      },


    mounted() {
        if(this.pointer.link_type === 'map') {
            if (this.objectCount >= 1) {
                this.status = 'Beschikbaar'
            }
            else {
                this.status = 'Verhuurd'
            }
        }
        if(this.pointer.link_type === 'eyemove_id') {
            this.status = this.objects[0].status
        }


    },

    computed: {
        objectCount(){
            if(this.pointer.link_type === 'map') {
                let path = this.map.paths[this.map.paths.length - 1] + '/' + this.map.slug
                return this.$filteredObjects.filter((object) => {
                    if (object.status !== 'Beschikbaar') {
                        return false
                    }
                    if (object.paths) {
                        return object.paths.includes(path);
                    }
                    return false
                }).length
            }
            return this.objects[0] && this.objects[0].status === 'Beschikbaar';
        },

        color(){
          const map = window.location.pathname.includes('popover');
          const {apiData} = this.$store.state;
          if(this.status === 'Beschikbaar' && apiData.status_available){
            return map ? apiData.map_status_available : apiData.status_available;
          }
          if((this.status === 'Onder optie' || this.status === 'Verkocht' || this.status === 'Verhuurd' || this.status === 'Verhuurd per maand' || this.status === 'Verhuurd onder voorbehoud') && apiData.status_sold){
            return map ? apiData.map_status_sold : apiData.status_sold;
          }
          return '';
        },

        objects(){
            let path = this.pointer.eyemove_id
            return this.$filteredObjects.filter((object) => {
                if (object.id === path) {
                    return object.status;
                }
                return false
            })
        }
    },

    methods: {
      polygonSelect(){
          if(this.pointer.link_type === 'map') {
              this.parent.getPolygonIndexMap(this.index);
          }
          if(this.pointer.link_type === 'eyemove_id') {
            let index = null;
            this.$filteredObjects.forEach((obj, i) => {
              if(obj.id === this.pointer.eyemove_id){
                index = i;
              }
            });
            this.parent.showTile(index, this.index);
              this.parent.getPolygonIndexFloor(this.index);
          }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .blink {
    animation-name: blink;
    animation-duration: 2s;
  }

  @keyframes blink {
    0%   {opacity: 0;}
    50%  {opacity: 0.5;}
    100% {opacity: 0;}
  }
</style>
